<template>
  <div class="quantum-superposition-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>|ψ⟩ = α|0⟩ + β|1⟩ | 薛定谔的猫态$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <defs>
             <filter id="glow">
                <feGaussianBlur stdDeviation="2.5" result="coloredBlur"/>
                <feMerge>
                   <feMergeNode in="coloredBlur"/><feMergeNode in="SourceGraphic"/>
                </feMerge>
             </filter>
          </defs>

          <!-- The Qubit (Bloch Sphere path) -->
          <circle cx="200" cy="120" r="80" fill="none" stroke="rgba(255,255,255,0.1)" stroke-dasharray="2,2" />
          
          <!-- State Vector -->
          <line x1="200" y1="120" :x2="200 + vecX" :y2="120 + vecY" 
                stroke="#00d2ff" stroke-width="3" filter="url(#glow)" />
          
          <!-- End point pulsing -->
          <circle :cx="200 + vecX" :cy="120 + vecY" r="4" fill="#00d2ff">
             <animate attributeName="r" values="4;6;4" dur="1s" repeatCount="indefinite" />
          </circle>

          <!-- Basis states -->
          <text x="195" y="30" fill="#fff" font-size="10">|0⟩ (上)</text>
          <text x="195" y="220" fill="#fff" font-size="10">|1⟩ (下)</text>

          <!-- The Probability Bar -->
          <rect x="340" y="40" width="20" height="160" rx="4" fill="rgba(255,255,255,0.05)" />
          <rect x="340" :y="40 + (1-prob0)*160" width="20" :height="prob0*160" rx="4" fill="#00d2ff" opacity="0.6" />
          <text x="310" y="30" fill="#888" font-size="7">观测概率 P(0)</text>
          <text x="310" y="220" fill="#888" font-size="7">观测概率 P(1)</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>探测时塌缩概率: |0⟩: {{ (prob0*100).toFixed(0) }}% | |1⟩: {{ ((1-prob0)*100).toFixed(0) }}%</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节叠加态相位</label>
             <el-slider v-model="angle" :min="0" :max="180" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>量子叠加是量子力学的核心原理。一个量子系统可以同时处于多个状态的线性组合中，直到被外部世界**观测**。在观测的那一刻，波函数会瞬时“塌缩”到其中一个基态上。叠加态不是指粒子在状态间快速跳动，而是其本质属性在未观测前是模糊且多重的。这是量子计算机实现并行计算的物理基础。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuantumSuperpositionConceptViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      angle: 90 // 0 to 180 (Theta on Bloch sphere)
    }
  },
  computed: {
    prob0() {
       // P(0) = cos(theta/2)^2
       let rad = (this.angle * Math.PI) / 180;
       return Math.pow(Math.cos(rad / 2), 2);
    },
    vecX() {
       return Math.sin((this.angle * Math.PI) / 180) * 80;
    },
    vecY() {
       return -Math.cos((this.angle * Math.PI) / 180) * 80;
    }
  }
}
</script>

<style scoped lang="scss">
.quantum-superposition-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
